module.exports = __webpack_public_path__ + "static/media/bangalow2.e471daee.png";